export const defaultGeojsonOptions = {
    paint: {},
    layout: {},
    minZoom: 0,
    maxZoom: 24,
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZ2VvanNvbi5qcyIsInNvdXJjZVJvb3QiOiJzcmMvIiwic291cmNlcyI6WyJvYmplY3RzL2dlb2pzb24udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBK0NBLE1BQU0sQ0FBQyxNQUFNLHFCQUFxQixHQUU5QjtJQUNILEtBQUssRUFBRSxFQUFFO0lBQ1QsTUFBTSxFQUFFLEVBQUU7SUFDVixPQUFPLEVBQUUsQ0FBQztJQUNWLE9BQU8sRUFBRSxFQUFFO0NBQ1gsQ0FBQSJ9